import * as types from '../constants/ActionTypes'
import config from '../../config/app.js';

export default function app(state = {
	title: config.title,
	version: 0,
	requestedRoute: null,
	authed: false,
	connected: false,
	authenticating: false,
	mustSendNotificationToken: false,
	practice: {
		name: '',
		userTypes: {},
		pendingUsers: [],
		parents: [],
		therapists: [],
		availablePatients: []
	},
	gettingToken: false
}, action) {
	switch (action.type) {
		case types.SET_TITLE:
			return { ...state, title: action.payload }

		case types.SET_STORE_VERSION:
			return { ...state, version: action.payload }

		case types.SET_CONNECTED:
			return { ...state, connected: action.payload }

		case types.SET_AUTHED:
			return { ...state, authed: action.payload, authenticating: false }

		case types.SET_AUTHENTICATING:
			return { ...state, authenticating: action.payload }

		case types.SET_APP_FIELD:
			return { ...state, [action.payload.field]: action.payload.value }

		case types.GETTING_TOKEN:
			return { ...state, gettingToken: action.payload }

		case types.REMOVE_APP_PRACTICE_AVAILABLE_PATIENT:
			return { ...state,
				practice: { ...state.practice,
					availablePatients: state.practice.availablePatients
						.filter(p => p._id !== action.payload)
				}
			}



		case types.SET_APP_PRACTICE_AVAILABLE_PATIENTS:
			return { ...state, practice: { ...state.practice, availablePatients: action.payload } }

		case types.SET_APP_PRACTICE_PENDING_USERS:
			return { ...state, practice: { ...state.practice, pendingUsers: action.payload } }

		case types.SET_APP_PRACTICE_PARENTS:
		let practice = { ...state.practice, parents: action.payload }
			return { ...state, practice: practice }

		case types.SET_APP_PRACTICE_THERAPISTS:
			return { ...state, practice: { ...state.practice, therapists: action.payload } }

		case types.SET_APP_PRACTICE:
			return { ...state, practice: action.payload };

		case types.SET_APP_PRACTICE_FIELD:
			return { ...state, practice: { ...state.practice, [`${action.payload.key}`]: action.payload.val } };

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/reducers/app.js